import { Tabs } from "@exopengithub/exokit";
import { TabLink } from "components/tabs/TabLink";
import type { ReactNode } from "react";
import { HeaderLayout } from "src/routes/HeaderLayout.js";

type Props = {
	isHierarchyTab: boolean;
	companiesLabel: string;
	groupStructureLabel: string;
	children: ReactNode;
};

/** Portable view for LegalEntitiesLayout — no routing hooks, so it renders in Storybook with just a MemoryRouter for TabLink. */
export const LegalEntitiesLayoutView = ({
	isHierarchyTab,
	companiesLabel,
	groupStructureLabel,
	children,
}: Props) => (
	<HeaderLayout
		title={isHierarchyTab ? groupStructureLabel : companiesLabel}
		tabs={
			<Tabs>
				<TabLink to="." end>
					{companiesLabel}
				</TabLink>
				<TabLink to="hierarchy">{groupStructureLabel}</TabLink>
			</Tabs>
		}
	>
		{children}
	</HeaderLayout>
);
